const isDevelopment = process.env.REACT_APP_IS_DEV === 'true';

export const API_BASE_URL = isDevelopment
  ? 'http://localhost:3000'
  : 'https://autohaus-seyfarth.de';

export const getApiUrl = (path) => {
  return `${API_BASE_URL}${path}`;
};
